document.addEventListener("DOMContentLoaded", function () {
  const button = document.getElementById("rd-chat-button");
  const chatWindow = document.getElementById("rd-chat-window");
  const closeButton = document.getElementById("rd-chat-close");

  if (!button || !chatWindow) {
    return;
  }

  button.addEventListener("click", function () {
    const isClosed = chatWindow.hasAttribute("hidden");

    if (isClosed) {
      chatWindow.removeAttribute("hidden");
      chatWindow.setAttribute("aria-hidden", "false");
      button.setAttribute("aria-expanded", "true");
    } else {
      chatWindow.setAttribute("hidden", "");
      chatWindow.setAttribute("aria-hidden", "true");
      button.setAttribute("aria-expanded", "false");
    }
  });

  if (closeButton) {
    closeButton.addEventListener("click", function () {
      chatWindow.setAttribute("hidden", "");
      chatWindow.setAttribute("aria-hidden", "true");
      button.setAttribute("aria-expanded", "false");
    });
  }
});